
import { Vue, Component, Ref } from "vue-property-decorator";
import axios from "axios";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";
import {ListDataSource} from "@/data/List/ListDataSource";
import {Filter} from "@/cms-services/filter";
import FileUploaderDialog from "@/components/helpers/file-uploader-dialog.vue";
import SyncMisDialog from "./sync-mis-dialog.vue";
import { mdiPlusCircleOutline, mdiUpload, mdiSync } from "@mdi/js";

@Component({
  components: { FileUploaderDialog, SyncMisDialog }
})
export default class Home extends Vue {
  @Ref("priceList") priceList!: any;
  $message: any;

  dataSource: ObjectDataSource = new ObjectDataSource({
    id: +this.$route.params.id,
    config: {},
    className: "priceCatalog",
  });

  icons: any = {
    circlePlus: mdiPlusCircleOutline,
    upload: mdiUpload,
    sync: mdiSync,
  };

  jsonDialogVisible: boolean = false;
  excelDialogVisible: boolean = false;
  syncDialogVisible: boolean = false;

  get breadcrumbs() {
    return [
      {
        text: "Главная",
        to: "/",
      },
      {
        text: "Каталог цен",
        to: "/manage/price-catalogs/",
        exact: true,
      },
      {
        text: this.dataSource.model?.caption,
        disabled: true,
      },
    ];
  }

  cretePriceItem:any = {
    priceCatalogId:+this.$route.params.id,
    caption:""
  }

  priceListDataSource: any = new ListDataSource({
    config: {
      pageIndex: 1,
      pageSize: 15,
      filter: JSON.stringify([
        new Filter("catalogId", +this.$route.params.id)
      ])
    },
    className: "pricelist",
  });

  async uploadJson(event: any) {
    try {
      await axios.post(
        `manage/pricecatalog/${this.$route.params.id}/upload/json`,
        event.data as FormData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      await this.priceList.refreshData();
      this.jsonDialogVisible = false;
      this.$message("Прайс загружен");
    } catch (error) {
      this.$message(
        (error as any)?.response?.data?.message ??
          (error as any)?.response?.data ??
          "Ошибка при загрузке файла",
        "error"
      );
    }
  }

  async uploadExcel(event: any) {
    try {
      await axios.post(
        `manage/pricecatalog/${this.$route.params.id}/upload/xlsx`,
        event.data as FormData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      await this.priceList.refreshData();
      this.excelDialogVisible = false;
      this.$message("Прайс загружен");
    } catch (error) {
      this.$message(
        (error as any)?.response?.data?.message ??
          (error as any)?.response?.data ??
          "Ошибка при загрузке файла",
        "error"
      );
    }
  }

  async onSyncApplied() {
    await this.priceList.refreshData();
  }
}
